var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative","width":"300px"}},[_c('Doughnut',{attrs:{"chart-data":_vm.chartData,"chart-options":_vm.chartOptions,"plugins":_vm.plugins}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }